export const ZendeskIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M10.5804 3.75L10.5804 12.6786L18.125 3.75H10.5804Z" fill="#16140D" />
      <path
        d="M5.64734 7.72727C7.71119 7.72727 9.41965 5.69079 9.41965 3.75001H1.87501C1.87501 5.69079 3.58349 7.72727 5.64734 7.72727Z"
        fill="#16140D"
      />
      <path
        d="M10.5804 16.25C10.5804 14.3092 12.2888 12.2727 14.3527 12.2727C16.4165 12.2727 18.125 14.3092 18.125 16.25H10.5804Z"
        fill="#16140D"
      />
      <path d="M9.41965 16.25V7.32143L1.875 16.25H9.41965Z" fill="#16140D" />
    </svg>
  );
};
